import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { loginOwner } from '../../services/authService';
import { toast } from 'react-toastify';
import { useAuth } from './context/AuthContext';

function OwnerLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { ownerLogin, isOwnerAuthenticated } = useAuth();

  useEffect(() => {
    if (isOwnerAuthenticated) {
      const { from } = location.state || { from: '/owner/dashboard' };
      navigate(from, { replace: true });
    }
  }, [isOwnerAuthenticated, navigate, location]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await loginOwner(email, password);
      if (response.token) {
        // localStorage.setItem('ownerToken', response.token);
        // navigate('/owner/dashboard');
        ownerLogin(response.token);
        toast.success('Login successful');
        const { from } = location.state || { from: '/owner/dashboard' };
        navigate(from, { replace: true });
      } else {
        toast.error('Invalid login credentials.');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex justify-center items-center h-screen bg-gray-100 dark:bg-gray-900'>
      <div className='bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md'>
        <h2 className='text-2xl font-bold mb-6 text-gray-900 dark:text-white'>
          Owner Login
        </h2>
        <form onSubmit={handleLogin}>
          <input
            type='email'
            className='w-full p-3 mb-4 border rounded-lg'
            placeholder='Enter your email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type='password'
            className='w-full p-3 mb-4 border rounded-lg'
            placeholder='Enter your password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type='submit'
            className='bg-blue-500 text-white py-2 px-4 rounded-lg w-full'
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div className='text-center mt-2'>
          <p className='text-gray-600 dark:text-gray-400'>
            Don't have an account?{' '}
            <Link
              to='/owner/signup'
              className='text-blue-500 hover:text-blue-600 font-medium'
            >
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default OwnerLogin;
// // // src/components/auth/OwnerLogin.js
// // import React, { useState } from 'react';
// // import { useHistory } from 'react-router-dom';
// import { loginOwner } from '../../services/authService';

// import React, { useState } from 'react';
// // import { ownerLogin } from '../services/authService';

// // import { useHistory } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';

// // import Toast from '../components/common/Toast';

// import { toast } from 'react-toastify';

// function OwnerLogin() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');

//   const [loading, setLoading] = useState(false);

//   //   const history = useHistory();
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       const response = await loginOwner({ email, password });
//       //   const response = await axios.post('/api/owner/login', { email, password });
//       // const response = await axios.post('/api/auth/owner-login', {
//       //   email,
//       //   password,
//       // });
//       if (response.token) {
//         localStorage.setItem('ownerToken', response.token);
//         toast.success('Login successful');

//         // history.push('/owner-dashboard');
//         navigate('/owner-dashboard');
//       } else {
//         setError('Invalid login credentials.');

//         toast.error('Invalid login credentials.');
//       }
//     } catch (error) {
//       setError('Login failed. Please check your credentials.');

//       toast.error('Login failed.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   //   const handleSubmit = async (e) => {
//   //     e.preventDefault();
//   //     try {
//   //       const response = await ownerLogin({ email, password });
//   //       localStorage.setItem('ownerToken', response.token);
//   //       Toast.success('Login successful');
//   //       navigate('/owner-dashboard');
//   //     } catch (error) {
//   //       Toast.error('Login failed. Please check your credentials.');
//   //     }
//   //   };

//   return (
//     <div className='flex justify-center items-center h-screen bg-gray-100 dark:bg-gray-900'>
//       <div className='bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md'>
//         <h2 className='text-2xl font-bold mb-6 text-gray-900 dark:text-white'>
//           Owner Login
//         </h2>
//         {error && <p className='text-red-500 mb-4'>{error}</p>}
//         <input
//           type='text'
//           className='w-full p-3 mb-4 border rounded-lg'
//           placeholder='Enter your email'
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//         <input
//           type='password'
//           className='w-full p-3 mb-4 border rounded-lg'
//           placeholder='Enter your password'
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />
//         <button
//           className='bg-blue-500 text-white py-2 px-4 rounded-lg'
//           onClick={handleLogin}
//           disabled={loading}
//         >
//           {loading ? 'Logging in...' : 'Login'}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default OwnerLogin;

// return (
//     <div className="max-w-md mx-auto mt-10">
//       <h1 className="text-3xl font-bold mb-6 text-center">Owner Login</h1>
//       <form onSubmit={handleSubmit}>
//         <div className="mb-4">
//           <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
//           <input
//             type="email"
//             id="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//             required
//           />
//         </div>
//         <div className="mb-4">
//           <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
//           <input
//             type="password"
//             id="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//             required
//           />
//         </div>
//         <button
//           type="submit"
//           className="w-full py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
//         >
//           Login
//         </button>
//       </form>
//     </div>
//   );

// return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
//       <h2 className="text-2xl font-bold mb-4">Owner Login</h2>
//       <input
//         type="email"
//         placeholder="Email"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         className="mb-2 p-2 border rounded"
//       />
//       <input
//         type="password"
//         placeholder="Password"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//         className="mb-2 p-2 border rounded"
//       />
//       <button
//         onClick={handleLogin}
//         className="bg-blue-500 text-white px-4 py-2 rounded"
//       >
//         Login
//       </button>
//     </div>
//   );
